/** @jsxImportSource @emotion/react */
import React from 'react';

interface Props {
  sx?: React.CSSProperties;
  onClick: () => void;
  disableSpin?: boolean;
  id?: string;
}

const Xbutton = ({ sx, onClick, disableSpin = false, id = null }: Props) => {
  return (
    <div id={id}>
      <svg
        className='x-button'
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        viewBox='0 0 24 24'
        strokeWidth='1.5'
        stroke='currentColor'
        css={{
          width: '28px',
          height: '28px',
          cursor: 'pointer',
          ...(sx ? sx : {}),
          transitionDuration: '0.2s',
          '&:hover': {
            transform: disableSpin ? '' : 'rotate(90deg)',
          },
        }}
        onClick={() => onClick()}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </div>

  );
};

export default Xbutton;
